<template>
  <div>
    <el-form ref="form" :model="form" :rules="rules">
      <ul class="error-messages" v-if="!isEmptyErrors">
        <li v-for="error in errors">{{error[0].message}}</li>
      </ul>
      <el-form-item v-if="form.country == '中国大陆(CN)'">
        <el-input v-model="addressAnalysis" placeholder="输入或粘贴文本,自动识别中国大陆地址" class="addressAnalysis" style="margin-top:10px;">
            <template slot="append"><div @click="aotuAddress()">自动识别</div> </template>
        </el-input>
      </el-form-item>
      <el-form-item>
        <el-row>
          <el-col :span="12">
            <el-radio v-model="form.transport_or_not" :label="'1'" @change="selectAddress()">转运地址</el-radio>
          </el-col>
          <el-col :span="12">
            <el-radio v-model="form.transport_or_not" :label="'2'" @change="selectAddress()">普通地址</el-radio>
          </el-col>
        </el-row>
      </el-form-item>
      <el-form-item prop="transport_company" v-if="form.transport_or_not == 1" class="companyPosition">
        <YueDanIpt model="transport_company" :object="form" placeholder="转运公司" :auto="true" v-on:input="debounceAutofill" ></YueDanIpt>
        <div class="companyList" v-if="showCompanyList">
          <div class="company" v-for="item in companyList" @click="confirm(item)">{{item.company+'-'+item.warehouse}}</div>
        </div>
      </el-form-item>
      <el-form-item prop="store_number" v-if="form.transport_or_not == 1">
        <YueDanIpt model="store_number" :object="form" placeholder="入库码" v-on:blur="blur"></YueDanIpt>
      </el-form-item>
      <el-row :gutter="20">
        <el-col :span="12" v-if="form.country == '中国大陆(CN)'">
          <el-form-item prop="last_name">
            <YueDanIpt model="last_name" :object="form" placeholder="姓"></YueDanIpt>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item prop="first_name">
            <YueDanIpt model="first_name" :object="form" placeholder="名"></YueDanIpt>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item prop="last_name" v-if="form.country != '中国大陆(CN)'">
            <YueDanIpt model="last_name" :object="form" placeholder="姓"></YueDanIpt>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item prop="country">
        <el-select class="height-50" v-model="form.country" placeholder="请选择地区" style="width: 100%;">
          <el-option
            v-for="item in COUNTRIES"
            :key="item.value"
            :label="item.name+'('+item.value+')'"
            :value="item.name+'('+item.value+')'">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="address1">
        <YueDanIpt model="address1" :object="form" placeholder="地址 1"></YueDanIpt>
      </el-form-item>
      <el-form-item>
        <YueDanIpt model="address2" :object="form" placeholder="地址 2（选填）"></YueDanIpt>
      </el-form-item>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item prop="city">
            <YueDanIpt model="city" :object="form" placeholder="城市"></YueDanIpt>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item prop="province">
            <YueDanIpt model="province" :object="form" placeholder="州/省"></YueDanIpt>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item prop="county">
            <YueDanIpt model="county" :object="form" placeholder="县/郡"></YueDanIpt>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item prop="zip_code">
            <YueDanIpt model="zip_code" :object="form" placeholder="邮编"></YueDanIpt>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item prop="mobile">
        <YueDanIpt model="mobile" :object="form" placeholder="电话"></YueDanIpt>
      </el-form-item>
      <el-form-item prop="type">
        <el-checkbox-group v-model="form.business_or_private">
          <el-checkbox label="这是私人地址" name="type"></el-checkbox>
        </el-checkbox-group>
      </el-form-item>
      <el-form-item>
        <el-button class="block" :type="btnType || 'info'" @click="submit()" :loading="loading">确定</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import YueDanIpt from '../../../components/YueDanIpt'
import api from '../../../services/api.js'
import { COUNTRIES } from '../../../services/constant'
import md5 from 'js-md5';
let _ = require('lodash')

export default {
  name: 'AddAddress',
  props: ['addressInfo', 'btnType','support_transport_service','addressSelect','needSave'],
  components: {
    YueDanIpt: YueDanIpt
  },
  computed: {
    taskInfo () {

	    return this.$store.state.taskInfo
    }
  },
  created () {
    this.aotuAddress()
    this.isSingle = this.$route.fullPath.indexOf('buyer') > -1;
    this.countryFilter()
    Object.assign(this.form, this.addressInfo || {})
  },
  data () {
    return {
      addressAnalysis:null,
      isSingle:false,
      COUNTRIES: COUNTRIES,
      errors: null,
      isEmptyErrors: true,
      loading: false,
      companyList: null,
      showCompanyList: false,
      form: {
        transport_or_not: '1',
        business_or_private: false,//false商业，true私人地址
        transport_company: null,//转运公司
        store_number: null,//入库码
        last_name: null,//姓
        first_name: null,//名
        address1: null,//地址1
        address2: null,//地址2
        country: null,//国家
        province: null,//州/省
        city: null,//城市
        county: null,//县
        zip_code: null,//邮编
        mobile: null//手机
      },
      rules: {
        transport_company: [
          { required: true, message: '转运公司是必填项', trigger: 'blur' },
          { min: 1, max: 40, message: '转运公司长度不能超过40个字符', trigger: 'blur' }
        ],
        store_number: [
          { required: true, message: '入库码是必填项', trigger: 'blur' },
          { min: 1, max: 20, message: '入库码长度不能超过20个字符', trigger: 'blur' }
        ],
        last_name: [
          { required: true, message: '姓是必填项', trigger: 'blur' },
          { min: 1, max: 30, message: '姓长度不能超过30个字符', trigger: 'blur' }
        ],
        first_name: [
          { required: true, message: '名是必填项', trigger: 'blur' },
          { min: 1, max: 60, message: '名长度不能超过60个字符', trigger: 'blur' }
        ],
        address1: [
          { required: true, message: '地址1是必填项', trigger: 'blur' },
          { min: 1, max: 400, message: '地址长度不能超过400个字符', trigger: 'blur' }
        ],
        country: [
          { required: true, message: '国家是必选项', trigger: 'change' },
          { min: 1, max: 50, message: '国家长度不能超过50个字符', trigger: 'blur' }
        ],
        province: [
          { required: true, message: '州/省是必填项', trigger: 'blur' },
          { min: 1, max: 50, message: '州/省长度不能超过50个字符', trigger: 'blur' }
        ],
        city: [
          { required: true, message: '城市是必填项', trigger: 'blur' },
          { min: 1, max: 50, message: '城市长度不能超过50个字符', trigger: 'blur' }
        ],
        zip_code: [
          { required: true, message: '邮编是必填项', trigger: 'blur' },
          { min: 1, max: 50, message: '邮编长度不能超过50个字符', trigger: 'blur' }
        ],
        mobile: [
          { required: true, message: '电话是必填项', trigger: 'blur' },
          { min: 1, max: 20, message: '电话长度不能超过20个字符', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    async aotuAddress(){
      let timestamp = new Date().getTime()
      let text = ''
      if(this.addressAnalysis){
        text = this.addressAnalysis
      }else{
        return
      }
      let res = await api.post(this, {
        path: 'buyer.php',
        api: 'resolve_address',
        data: {address:text},
        loading: 'loading'
      });
      if(res.body.result.msg == '成功'){
          let address = res.body.result.data[0]
          if(address.province_name){
            this.form.province = address.province_name
          }
          /*else{
            this.form.province = ''
          }*/
          if(address.city_name){
            this.form.city = address.city_name
          }
          /*else{
            this.form.city = ''
          }*/
          if(address.county_name){
             this.form.county = address.county_name
           }
           /*else{
             this.form.county = ''
           }*/
          if(address.detail){
            this.form.address1 = address.detail
          }
          /*else{
            this.form.address1 = ''
          }*/
          if(address.name){
            console.log(address.name.length)
            if(address.name.length<4){
              this.form.last_name = address.name.slice(0,1)
              this.form.first_name = address.name.slice(1)
            }else{
              this.form.last_name = address.name.slice(0,2)
              this.form.first_name = address.name.slice(2)
            }
          }
          if(address.mobile){
            this.form.mobile = address.mobile
          }
          /*else{
            this.form.mobile = ''
          }*/
      }
      // this.$http.post('https://kop.kuaidihelp.com/api',{
      //   app_id: '104830',
      //   method: 'cloud.address.resolve',
      //   ts: timestamp,
      //   sign: md5('104830'+'cloud.address.resolve'+timestamp+'db4456836409beeb45f13859a6d08322300d2d45'),
      //   data:'{"text":"'+text +'","multimode":false}'
      //   },
      //   {emulateJSON: true}
      // ).then(
      //   function(res){
      //     if(res.body.msg == '成功'){
      //       console.log(res.body.data)
      //       let address = res.body.data[0]
      //       if(address.province_name){
      //         this.form.province = address.province_name
      //       }
      //       if(address.city_name){
      //         this.form.city = address.city_name
      //       }
      //       if(address.county_name){
      //         this.form.county = address.county_name
      //       }
      //       if(address.mobile){
      //         this.form.mobile = address.mobile
      //       }
      //     }
      //   }
      // )
    },
    analysisAddress(){
      console.log(1)
    },
    countryFilter () {
      if(this.support_transport_service == '2'){
        this.form.transport_or_not = '2'
        this.form.business_or_private = true
        this.form.country = '中国大陆(CN)'
        this.COUNTRIES = [
          {value: 'CN', name: '中国大陆', name_en: 'China'},
          {value: 'HK', name: '中国香港', name_en: 'Hong Kong'},
        ]
      }
    },
    selectAddress () {
      this.form.transport_company = null
      this.form.store_number = null
      this.form.last_name = null
      this.form.first_name = null
      this.form.address1 = null
      this.form.address2 = null
      this.form.country = null
      this.form.province = null
      this.form.city = null
      this.form.county = null
      this.form.zip_code = null
      this.form.mobile = null
      if(this.form.transport_or_not == 1) {
        this.form.business_or_private = false
      }else{
        this.form.business_or_private = true
        this.form.country = '中国大陆(CN)'
      }
    },
    debounceAutofill: _.debounce(function(data) {
      this.aotufill(data)
    }, 300),
    async aotufill (data) {
      this.companyList = []
      if(data.length > 0){
        let query = {
          name: data
        }
        let res = await api.getTransportCompanyList(this,query)
        
        this.getAddressList(res)
      }else{
        this.showCompanyList = false
      }
    },
    async getAddressList (res) {
      if(res.body.result){
        for(let item in res.body.result){
          let queryAddress = {
            keyword: res.body.result[item].name
          }
          let address = await api.getTransportAddressList(this,queryAddress)
          
          let addressList =  address.body.result
          let addressCty = ''
          _.each(addressList,list => {
            _.each(this.COUNTRIES,country => {
              if(list.country == country.value){
                addressCty = country.name+'('+country.value+')'
              }
            })
            let arrStr = {
              last_name:list.last_name,
              first_name:list.first_name,
              city:list.city,
              province:list.province,
              county:list.county,
              zip_code:list.zip_code,
              mobile:list.mobile,
              company:res.body.result[item].name,
              warehouse:list.name,
              address1:list.address1,
              address2:list.address2,
              country:addressCty,
              }
            this.companyList.push(arrStr)
            console.log('this.companyList',this.companyList)
            if(this.companyList == []){
              this.showCompanyList = false
            }else{
              this.showCompanyList = true
            }
          })

        }
      }
    },
    blur (data) {
      
      this.form.store_number = data.replace(/#/g,'')
    },
    async confirm (item){
      this.form.transport_company = item.company+'-'+item.warehouse
      this.form.address1 = item.address1
      this.form.address2 = item.address2
      this.form.country = item.country
      this.form.last_name = item.last_name
      this.form.first_name = item.first_name
      this.form.city = item.city
      this.form.county = item.county
      this.form.zip_code = item.zip_code
      this.form.mobile = item.mobile
      this.form.province = item.province
      this.showCompanyList = false
    },
    submit () {
      this.$refs['form'].validate(async (valid, errors) => {
        this.isEmptyErrors = _.isEmpty(errors)
        this.errors = errors
        if (!valid) {
          return false;
        }
        this.form.business_or_private = this.form.business_or_private ? 2: 1
        if(!this.isSingle || this.needSave){
          let id = await this.saveAddress()
          this.taskInfo.address_id = id
        }else{
          this.taskInfo.address_id = 0         
        }
        this.form.address_id=this.taskInfo.address_id
        this.taskInfo.address_info = this.form
        this.$store.commit('updateTaskInfo', this.taskInfo)
        this.$emit('success', this.form)
      })
    },
    async saveAddress () {
      let apiAddress = 'add_address';
      if (this.form.id) {
        apiAddress = 'update_address';
        this.form.address_id = this.form.id
      }
      let res = await api.post(this, {
        path: 'buyer.php',
        api: apiAddress,
        data: this.form,
        loading: 'loading'
      });
      if (this.form.id) {
        return this.form.id

      }
      return res.body.result
    }
  },
  watch: {
    addressSelect:{
      handler(newValue,oldValue){
        Object.assign(this.form, newValue || {})
      },
      deep:true
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.companyPosition {
  position: relative;
}
  .companyList  {
    position: absolute;
    top: 50px;
    z-index: 999;
    width: 100%;
    max-height: 500px;
    background-color: #ffffff;
    border-width: 0 1px 1px;
    border-color: #C6C9CB;
    border-style: solid;
    overflow: auto;
  }
    .company{
      height: 50px;
      border-bottom: 1px solid #C6C9CB;
      width: 100%;
      display: block;
      font-size: 14px;
      padding: 10px;
      line-height: 28px;
      background: transparent;
      box-sizing: border-box;
      color: #606266;
    }
    .company:hover{
      background-color: #333;
      color: #fff;
    }
</style>



// WEBPACK FOOTER //
// src/pages/publish_task/address/Form.vue